export default "__VITE_ASSET__DmhlMqY4__"